import React, { useLayoutEffect, useRef, useState } from 'react';
import { View, TextInput, Alert } from 'react-native';
import Text, { styles as textStyles } from 'design-system/Text';
import emoji from 'node-emoji';
import validator from 'email-validator';
import StatusBar from 'design-system/StatusBar';
import { AppView } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import { KeyboardAvoidingContainerNew } from 'design-system/KeyboardAvoidingContainerNew';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
const ClaimEmailScreen = ({ route, navigation, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
            headerTitle: () => (<Text Text-18 centered>
          Enter email
        </Text>),
        });
    }, [colors.text.primary]);
    const [state, setState] = useState({
        email: '',
    });
    const openExportFinished = () => {
        const { params = {} } = route;
        const trimmedEmail = state.email.trim();
        if (!validator.validate(trimmedEmail) || !trimmedEmail.length) {
            Alert.alert(emoji.emojify('Hold on :dizzy:'), 'You must enter an email.');
            return;
        }
        navigation.navigateDeprecated('ConfirmClaimEmail', {
            ...params,
            email: trimmedEmail,
        });
    };
    const onChangeText = (data) => {
        setState({ email: data.trim() });
    };
    const textInputRef = useRef(null);
    useAutoFocusInput(textInputRef);
    return (<AppView avoidHeader>
      <StatusBar barStyle="dark-content" animated/>
      <KeyboardAvoidingContainerNew flexContainer withButtonSpace>
        <View style={styles.container}>
          <TextInput ref={textInputRef} value={state.email} autoComplete="email" autoCapitalize="none" allowFontScaling={false} onChangeText={onChangeText} keyboardType="email-address" textContentType="emailAddress" underlineColorAndroid="transparent" selectionColor={colors.text.selection} placeholder="Your PayPal email address" placeholderTextColor={colors.text.placeholder} style={styles.textinput}/>
        </View>
      </KeyboardAvoidingContainerNew>
      <KeyboardAvoidingButton brand title="Continue" onPress={openExportFinished} disabled={!state.email.trim()} withFrame={false}/>
    </AppView>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        justifyContent: 'center',
    },
    textinput: {
        textAlign: 'center',
        textAlignVertical: 'center',
        justifyContent: 'center',
        color: colors.text.primary,
        // Font only: `lineHeight: undefined` after a text style's line height makes
        // Android, on the New Architecture, apply a line height of 0 and hide the text.
        fontFamily: textStyles.TextThin_24.fontFamily,
        fontSize: textStyles.TextThin_24.fontSize,
    },
}));
export default ClaimEmailScreen;
